import React, { useState, useEffect, Fragment, useRef } from 'react';
import { useSelector } from 'react-redux';
import {
  Container,
  Grid,
  Card,
  Typography,
  TextField,
  Button,
  Avatar,
  Box,
  Fab,
  Dialog,
  DialogContent,
  DialogTitle,
  DialogActions,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Chip,
  IconButton
} from '@material-ui/core';
import {
  Person,
  Edit,
  Save,
  Cancel,
  PhotoCamera,
  Business,
  VerifiedUser,
  WorkOutline,
  TrendingUp,
  Close,
  CloudUpload
} from '@material-ui/icons';
import { makeStyles } from '@material-ui/core/styles';
import '../../components/Admin/TheOilsBabe.css';
import userService from '../../services/userService';
import NewNavbar from '../../new-components/NewNavbar';
import NewPageHeader from "../../new-components/NewPageHeader";
import NewOverrides from '../../new-components/NewOverrides';
import NewDesignSystem from '../../new-components/NewDesignSystem';
import NewFooter from '../../new-components/NewFooter';
import NewMadeWith from '../../new-components/NewMadeWith';
import NewScrollTop from '../../new-components/NewScrollTop';
import { useLanguage } from '../../contexts/LanguageContext';
import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import { storage } from '../../main-component/Firebase';
import { toast } from 'react-toastify';
import { RANK_OPTIONS, getRankStyle } from '../../utils/rankStyles';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: 'var(--background-color, #fff)',
    minHeight: '100vh',
    paddingTop: '120px', // Increased padding to avoid navbar intersection
    transition: 'background-color 0.3s ease',
  },
  heroSection: {
    backgroundColor: 'var(--surface-color, #fff)',
    color: 'var(--text-primary, #904d71)',
    padding: '40px 0',
    position: 'relative',
    overflow: 'hidden',
    marginBottom: '40px',
    border: '1px solid var(--border-color, #e7dedf)',
    borderRadius: '16px',
    boxShadow: '0 4px 20px var(--shadow-color, rgba(144, 77, 113, 0.08))',
    transition: 'all 0.3s ease',
  },
  profileHeader: {
    display: 'flex',
    alignItems: 'center',
    gap: '24px',
    position: 'relative',
    zIndex: 1,
  },
  profileAvatar: {
    position: 'relative',
  },
  avatar: {
    width: 120,
    height: 120,
    fontSize: '2.5rem',
    fontWeight: 'bold',
    backgroundColor: '#d9ba91',
    color: '#904d71',
    border: '4px solid white',
    boxShadow: '0 8px 24px rgba(0,0,0,0.15)',
  },
  avatarButton: {
    position: 'absolute',
    bottom: 0,
    right: 0,
    backgroundColor: '#d9ba91',
    color: '#904d71',
    width: 40,
    height: 40,
    '&:hover': {
      backgroundColor: '#c9aa81',
      transform: 'scale(1.1)',
    }
  },
  profileInfo: {
    flex: 1,
  },
  userName: {
    fontSize: '2.5rem',
    fontWeight: 'bold',
    marginBottom: '8px',
    color: 'var(--text-primary, #904d71)',
  },
  userEmail: {
    fontSize: '1.1rem',
    opacity: 0.7,
    marginBottom: '16px',
    color: 'var(--text-secondary, #904d71)',
  },
  rankChip: {
    color: 'var(--rank-text-light)',
    fontWeight: 'bold',
    fontSize: '0.9rem',
    padding: '8px 16px',
    height: 'auto',
    borderRadius: 'var(--radius-pill)',
  },
  contentSection: {
    padding: '0 0 32px',
  },
  sectionCard: {
    borderRadius: '16px',
    boxShadow: '0 4px 20px var(--shadow-color, rgba(144, 77, 113, 0.08))',
    border: '1px solid var(--border-color, #e7dedf)',
    overflow: 'hidden',
    marginBottom: '24px',
    backgroundColor: 'var(--surface-color, #fff)',
    transition: 'all 0.3s ease',
  },
  sectionHeader: {
    padding: '24px 24px 16px',
    borderBottom: '1px solid var(--border-color, #e7dedf)',
    backgroundColor: 'var(--surface-color, white)',
    transition: 'background-color 0.3s ease, border-color 0.3s ease',
  },
  sectionTitle: {
    fontSize: '1.4rem',
    fontWeight: 'bold',
    color: 'var(--primary-color, #904d71)',
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
  },
  sectionContent: {
    padding: '24px',
    backgroundColor: 'var(--surface-color, white)',
    transition: 'background-color 0.3s ease',
  },
  formField: {
    marginBottom: '24px',
    '& .MuiOutlinedInput-root': {
      borderRadius: '12px',
      backgroundColor: 'var(--input-background, rgba(255, 255, 255, 0.9))',
      backdropFilter: 'blur(10px)',
      transition: 'all 0.3s ease',
      '&:hover fieldset': {
        borderColor: '#904d71',
        boxShadow: '0 0 0 1px rgba(144, 77, 113, 0.1)',
      },
      '&.Mui-focused fieldset': {
        borderColor: '#904d71',
        borderWidth: '2px',
        boxShadow: '0 0 0 3px rgba(144, 77, 113, 0.1)',
      },
      '&.Mui-disabled': {
        backgroundColor: 'var(--input-disabled-background, rgba(0, 0, 0, 0.04))',
      },
    },
    '& .MuiInputLabel-outlined': {
      fontSize: '1rem',
      fontWeight: '500',
      letterSpacing: '0.01em',
      color: 'var(--label-color, rgba(0, 0, 0, 0.7))',
      '&.Mui-focused': {
        color: '#904d71',
        fontWeight: '600',
      },
      '&.Mui-disabled': {
        color: 'var(--label-disabled-color, rgba(0, 0, 0, 0.38))',
      },
    },
    '& .MuiInputBase-input': {
      fontSize: '1rem',
      fontWeight: '400',
      letterSpacing: '0.01em',
      padding: '14px 16px',
    },
    '& .MuiFormHelperText-root': {
      fontSize: '0.875rem',
      marginTop: '8px',
      color: 'var(--helper-text-color, rgba(0, 0, 0, 0.6))',
      fontWeight: '400',
    },
  },
  actionButton: {
    borderRadius: '12px',
    padding: '12px 24px',
    textTransform: 'none',
    fontWeight: 600,
    fontSize: '1rem',
    transition: 'all 0.3s ease',
  },
  primaryButton: {
    backgroundColor: '#904d71',
    color: 'white',
    '&:hover': {
      backgroundColor: '#6c3d51',
      transform: 'translateY(-2px)',
      boxShadow: '0 6px 20px rgba(144, 77, 113, 0.3)',
    },
  },
  secondaryButton: {
    backgroundColor: '#d9ba91',
    color: '#904d71',
    marginLeft: '12px',
    '&:hover': {
      backgroundColor: '#c9aa81',
      transform: 'translateY(-2px)',
    },
  },
  // Rank promotion card styles
  rankCard: {
    background: 'linear-gradient(135deg, #904d71 0%, #d9ba91 100%)',
    color: 'white',
    borderRadius: '20px',
    padding: '32px',
    position: 'relative',
    overflow: 'hidden',
    marginBottom: '24px',
    boxShadow: '0 15px 35px rgba(144, 77, 113, 0.3)',
    transition: 'all 0.3s ease',
    '&:hover': {
      transform: 'translateY(-5px)',
      boxShadow: '0 20px 45px rgba(144, 77, 113, 0.4)',
    }
  },
  rankCardPattern: {
    position: 'absolute',
    top: 0,
    right: 0,
    width: '200px',
    height: '200px',
    background: 'radial-gradient(circle, rgba(255,255,255,0.1) 0%, transparent 70%)',
    borderRadius: '50%',
    transform: 'translate(50px, -50px)',
  },
  rankCardContent: {
    position: 'relative',
    zIndex: 2,
  },
  rankCardTitle: {
    fontSize: '1.8rem',
    fontWeight: 'bold',
    marginBottom: '16px',
  },
  currentRank: {
    display: 'inline-flex',
    alignItems: 'center',
    backgroundColor: 'rgba(255, 255, 255, 0.2)',
    padding: '8px 16px',
    borderRadius: '25px',
    fontSize: '1rem',
    fontWeight: '600',
    marginBottom: '20px',
  },
  rankSelectField: {
    '& .MuiOutlinedInput-root': {
      backgroundColor: 'rgba(255, 255, 255, 0.1)',
      borderRadius: '12px',
      color: 'white',
      '& fieldset': {
        borderColor: 'rgba(255, 255, 255, 0.3)',
      },
      '&:hover fieldset': {
        borderColor: 'rgba(255, 255, 255, 0.5)',
      },
      '&.Mui-focused fieldset': {
        borderColor: 'white',
      },
    },
    '& .MuiInputLabel-outlined': {
      color: 'rgba(255, 255, 255, 0.7)',
      '&.Mui-focused': {
        color: 'white',
      },
    },
    '& .MuiSelect-icon': {
      color: 'white',
    },
  },
  promotionButton: {
    backgroundColor: 'rgba(255, 255, 255, 0.2)',
    color: 'white',
    borderColor: 'rgba(255, 255, 255, 0.3)',
    borderRadius: '25px',
    padding: '12px 32px',
    fontWeight: '600',
    fontSize: '1rem',
    textTransform: 'none',
    transition: 'all 0.3s ease',
    '&:hover': {
      backgroundColor: 'rgba(255, 255, 255, 0.3)',
      borderColor: 'rgba(255, 255, 255, 0.5)',
      transform: 'scale(1.05)',
    },
  },
  imageUploadContainer: {
    position: 'relative',
    display: 'inline-block',
  },
  hiddenFileInput: {
    position: 'absolute',
    width: 0.1,
    height: 0.1,
    opacity: 0,
    overflow: 'hidden',
  },
}));

const ProfilePageMain = () => {
  const classes = useStyles();
  const { user } = useSelector((store) => store);
  const { t, language } = useLanguage();
  const [isEditing, setIsEditing] = useState(false);
  const [editedUser, setEditedUser] = useState({});
  const [loading, setLoading] = useState(false);
  const [profileImage, setProfileImage] = useState(null);
  const [imagePreview, setImagePreview] = useState(null);
  const [imageUploading, setImageUploading] = useState(false);
  const [promotionDialogOpen, setPromotionDialogOpen] = useState(false);
  const [selectedRank, setSelectedRank] = useState('');
  const [promotionLoading, setPromotionLoading] = useState(false);
  const fileInputRef = useRef(null);

  // Available ranks for promotion
  const availableRanks = RANK_OPTIONS.map((rank) => ({
    ...rank,
    label: language === 'en' && rank.value === 'Membru' ? 'Member' : rank.label,
  }));

  useEffect(() => {
    if (user?.user) {
      const userData = { ...user.user };
      
      // Auto-populate firstName and lastName from displayName if they're empty
      if (!userData.firstName && !userData.lastName && userData.displayName) {
        const nameParts = userData.displayName.trim().split(' ');
        if (nameParts.length >= 1) {
          userData.firstName = nameParts[0];
          if (nameParts.length >= 2) {
            userData.lastName = nameParts.slice(1).join(' ');
          }
        }
      }
      
      // For direct platform registrations, populate from email if name fields are empty
      if (!userData.firstName && !userData.lastName && !userData.displayName && userData.email) {
        // Extract name from email if possible (e.g., john.doe@example.com -> John Doe)
        const emailName = userData.email.split('@')[0];
        if (emailName.includes('.')) {
          const nameParts = emailName.split('.');
          userData.firstName = nameParts[0].charAt(0).toUpperCase() + nameParts[0].slice(1);
          userData.lastName = nameParts[1].charAt(0).toUpperCase() + nameParts[1].slice(1);
        } else {
          userData.firstName = emailName.charAt(0).toUpperCase() + emailName.slice(1);
          userData.lastName = '';
        }
      }
      
      // Ensure phone field is available for editing and auto-populate if empty
      if (!userData.phoneNumber && !userData.phone) {
        userData.phoneNumber = '';
        userData.phone = '';
        // For direct registrations, you could also prompt for phone number entry
      }
      
      setEditedUser(userData);
    }
  }, [user]);

  const getInitials = () => {
    const name = user?.user?.displayName || user?.user?.name || user?.user?.email || 'U';
    return name.split(' ').map(n => n.charAt(0)).join('').toUpperCase().substring(0, 2);
  };

  const getUserDisplayName = () => {
    return user?.user?.displayName || user?.user?.name || user?.user?.email || 'Utilizator';
  };

  const handleEditToggle = () => {
    if (isEditing) {
      setEditedUser({ ...user.user });
    }
    setIsEditing(!isEditing);
  };

  const handleSave = async () => {
    setLoading(true);
    try {
      // Validate required fields
      if (!editedUser.email || !editedUser.firstName || !editedUser.lastName) {
        throw new Error('Completați toate câmpurile obligatorii');
      }

      // Validate doTERRA fields if they exist
      if (editedUser.hasDoterraAccount === 'yes') {
        if (!editedUser.doterraFullName || !editedUser.doterraId || !editedUser.doterraEmail) {
          throw new Error('Completați toate câmpurile doTERRA obligatorii');
        }
      }

      await userService.updateProfile(user.user.uid, editedUser);
      setIsEditing(false);
      // You might want to dispatch an action to update the store
    } catch (error) {
      console.error('Error updating profile:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleInputChange = (field, value) => {
    setEditedUser(prev => ({ ...prev, [field]: value }));
  };

  const handleAddDoterraAccount = () => {
    setEditedUser(prev => ({ ...prev, hasDoterraAccount: 'yes' }));
  };

  // Image upload handlers
  const handleImageUpload = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    // Validate file type
    if (!file.type.startsWith('image/')) {
      toast.error('Vă rugăm să selectați un fișier imagine valid.');
      return;
    }

    // Validate file size (max 5MB)
    if (file.size > 5 * 1024 * 1024) {
      toast.error('Imaginea este prea mare. Mărimea maximă permisă este de 5MB.');
      return;
    }

    setImageUploading(true);
    setProfileImage(file);

    // Create preview
    const reader = new FileReader();
    reader.onload = (e) => {
      setImagePreview(e.target.result);
    };
    reader.readAsDataURL(file);

    try {
      // Upload to Firebase Storage
      // Use firebaseUid for the storage path since that's what's used in authentication
      const imageRef = ref(storage, `profile-images/${user.user.firebaseUid || user.user.uid}`);
      await uploadBytes(imageRef, file);
      const downloadURL = await getDownloadURL(imageRef);

      // Update user profile with new image URL
      const userId = user.user.id || user.user.uid;
      const updatedUser = { ...editedUser, profileImageUrl: downloadURL };
      await userService.updateProfile(userId, updatedUser);
      
      setEditedUser(updatedUser);
      toast.success('Imaginea de profil a fost actualizată cu succes!');
      
      // Update the local Redux store or refetch user data
      // For now, we'll just update the edited user state
      // You may want to dispatch an action to update the Redux store as well
    } catch (error) {
      console.error('Error uploading image:', error);
      if (error.code === 'storage/unauthorized') {
        toast.error('Eroare de autorizare Firebase Storage. Contactați administratorul pentru configurarea permisiunilor.');
      } else {
        toast.error('Eroare la încărcarea imaginii. Vă rugăm să încercați din nou.');
      }
    } finally {
      setImageUploading(false);
    }
  };

  const handlePhotoUploadClick = () => {
    fileInputRef.current?.click();
  };

  // Rank promotion handlers
  const handlePromotionRequest = async () => {
    if (!selectedRank) {
      toast.error('Vă rugăm să selectați un rank pentru promovare.');
      return;
    }

    setPromotionLoading(true);

    try {
      const promotionRequest = {
        userId: user.user.uid,
        userEmail: user.user.email,
        fullName: `${editedUser.firstName || ''} ${editedUser.lastName || ''}`.trim(),
        currentRank: editedUser.rank || 'Membru',
        requestedRank: selectedRank,
        requestDate: new Date().toISOString(),
        status: 'pending',
        avatarUrl: imagePreview || editedUser.profileImageUrl || user.user.photoURL || '',
        userDetails: {
          doterraId: editedUser.doterraId || '',
          doterraEmail: editedUser.doterraEmail || '',
          mentorId: editedUser.mentorDoterraId || '',
          mentorName: editedUser.mentorFullName || ''
        }
      };

      // Create promotion request (this will need to be implemented in userService)
      await userService.createPromotionRequest(promotionRequest);
      
      toast.success(t('rank.success', { rank: selectedRank }));
      setPromotionDialogOpen(false);
      setSelectedRank('');
    } catch (error) {
      console.error('Error creating promotion request:', error);
      toast.error(t('rank.error'));
    } finally {
      setPromotionLoading(false);
    }
  };

  const getCurrentRankDetails = () => {
    const currentRank = editedUser.rank || 'Membru';
    const rankDetails = availableRanks.find(rank => rank.value === currentRank);
    return rankDetails || availableRanks[0];
  };

  return (
    <Fragment>
      <NewNavbar />
      <NewOverrides />
      <NewDesignSystem />

      <NewPageHeader />
      <Box className={classes.root}>
        <Container maxWidth="lg">
          {/* Profile Header */}
          <div className={classes.heroSection}>
            <Container>
              <div className={classes.profileHeader}>
                <div className={classes.profileAvatar}>
                  <div className={classes.imageUploadContainer}>
                    <Avatar 
                      className={classes.avatar}
                      src={imagePreview || editedUser?.profileImageUrl || user?.user?.photoURL}
                    >
                      {!imagePreview && !editedUser?.profileImageUrl && !user?.user?.photoURL && getInitials()}
                    </Avatar>
                    <Fab
                      size="small"
                      className={classes.avatarButton}
                      onClick={handlePhotoUploadClick}
                      disabled={imageUploading}
                    >
                      {imageUploading ? <CloudUpload /> : <PhotoCamera />}
                    </Fab>
                    <input
                      ref={fileInputRef}
                      type="file"
                      accept="image/*"
                      onChange={handleImageUpload}
                      className={classes.hiddenFileInput}
                    />
                  </div>
                </div>
                <div className={classes.profileInfo}>
                  <Typography className={classes.userName}>
                    {getUserDisplayName()}
                  </Typography>
                  <Typography className={classes.userEmail}>
                    {user?.user?.email}
                  </Typography>
                  {editedUser?.rank && (
                    <Chip
                      label={availableRanks.find(r => r.value === editedUser.rank)?.label || editedUser.rank}
                      className={classes.rankChip}
                      style={{
                        ...getRankStyle(editedUser.rank)
                      }}
                    />
                  )}
                </div>
              </div>
            </Container>
          </div>

          <div className={classes.contentSection}>
            {/* Personal Information Section */}
            <Card className={classes.sectionCard}>
              <div className={classes.sectionHeader}>
                <Typography className={classes.sectionTitle}>
                  <Person />
                  {t('profile.personalInfo')}
                </Typography>
              </div>
              <div className={classes.sectionContent}>
                <Grid container spacing={3}>
                  <Grid item xs={12} md={6}>
                    <TextField
                      fullWidth
                      label="Email"
                      value={editedUser?.email || ''}
                      disabled={!isEditing}
                      onChange={(e) => handleInputChange('email', e.target.value)}
                      className={classes.formField}
                      variant="outlined"
                      required
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <TextField
                      fullWidth
                      label={t('profile.firstName')}
                      value={editedUser?.firstName || ''}
                      disabled={!isEditing}
                      onChange={(e) => handleInputChange('firstName', e.target.value)}
                      className={classes.formField}
                      variant="outlined"
                      required
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <TextField
                      fullWidth
                      label={t('profile.lastName')}
                      value={editedUser?.lastName || ''}
                      disabled={!isEditing}
                      onChange={(e) => handleInputChange('lastName', e.target.value)}
                      className={classes.formField}
                      variant="outlined"
                      required
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <TextField
                      fullWidth
                      label={t('profile.phone')}
                      value={editedUser?.phoneNumber || ''}
                      disabled={!isEditing}
                      onChange={(e) => handleInputChange('phoneNumber', e.target.value)}
                      className={classes.formField}
                      variant="outlined"
                    />
                  </Grid>
                </Grid>

                <Box mt={3} display="flex" justifyContent="flex-end" gap={2}>
                  {isEditing ? (
                    <>
                      <Button
                        onClick={handleEditToggle}
                        className={`${classes.actionButton} ${classes.secondaryButton}`}
                        startIcon={<Cancel />}
                      >
                        {t('profile.cancel')}
                      </Button>
                      <Button
                        onClick={handleSave}
                        className={`${classes.actionButton} ${classes.primaryButton}`}
                        startIcon={<Save />}
                        disabled={loading}
                      >
                        {t('profile.save')}
                      </Button>
                    </>
                  ) : (
                    <Button
                      onClick={handleEditToggle}
                      className={`${classes.actionButton} ${classes.primaryButton}`}
                      startIcon={<Edit />}
                    >
                      {t('profile.edit')}
                    </Button>
                  )}
                </Box>
              </div>
            </Card>

            {/* doTERRA Information Section */}
            {editedUser?.hasDoterraAccount === 'yes' ? (
              <Card className={classes.sectionCard}>
                <div className={classes.sectionHeader}>
                  <Typography className={classes.sectionTitle}>
                    <VerifiedUser />
                    {t('profile.doterraInfo')}
                  </Typography>
                </div>
                <div className={classes.sectionContent}>
                  <Grid container spacing={3}>
                    <Grid item xs={12} md={6}>
                      <TextField
                        fullWidth
                        label="Nume complet doTERRA"
                        value={editedUser?.doterraFullName || ''}
                        disabled={!isEditing}
                        onChange={(e) => handleInputChange('doterraFullName', e.target.value)}
                        className={classes.formField}
                        variant="outlined"
                        required
                      />
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <TextField
                        fullWidth
                        label="ID doTERRA"
                        value={editedUser?.doterraId || ''}
                        disabled={!isEditing}
                        onChange={(e) => handleInputChange('doterraId', e.target.value)}
                        className={classes.formField}
                        variant="outlined"
                        required
                      />
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <TextField
                        fullWidth
                        label="Email doTERRA"
                        value={editedUser?.doterraEmail || ''}
                        disabled={!isEditing}
                        onChange={(e) => handleInputChange('doterraEmail', e.target.value)}
                        className={classes.formField}
                        variant="outlined"
                        required
                      />
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <TextField
                        fullWidth
                        label="Telefon doTERRA"
                        value={editedUser?.doterraPhone || ''}
                        disabled={!isEditing}
                        onChange={(e) => handleInputChange('doterraPhone', e.target.value)}
                        className={classes.formField}
                        variant="outlined"
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <TextField
                        fullWidth
                        label="Mentor"
                        value={`${editedUser?.mentorFullName || ''} ${editedUser?.mentorDoterraId ? `(ID: ${editedUser.mentorDoterraId})` : ''}`}
                        disabled={!isEditing}
                        onChange={(e) => handleInputChange('mentorFullName', e.target.value)}
                        className={classes.formField}
                        variant="outlined"
                        helperText="Format: Nume Complet (ID: 12345)"
                      />
                    </Grid>
                  </Grid>
                </div>
              </Card>
            ) : (
              <Card className={classes.sectionCard}>
                <div className={classes.sectionHeader}>
                  <Typography className={classes.sectionTitle}>
                    <Business />
                    {t('profile.doterraAccount')}
                  </Typography>
                </div>
                <div className={classes.sectionContent}>
                  <Typography variant="body1" style={{ marginBottom: '20px', color: '#666' }}>
                    {t('profile.noDoterraAccount')}
                  </Typography>
                  <Button
                    onClick={handleAddDoterraAccount}
                    className={`${classes.actionButton} ${classes.primaryButton}`}
                    startIcon={<WorkOutline />}
                  >
                    {t('profile.addDoterraAccount')}
                  </Button>
                </div>
              </Card>
            )}

            {/* Rank Promotion Request Card */}
            {editedUser?.hasDoterraAccount === 'yes' && (
              <div className={classes.rankCard}>
                <div className={classes.rankCardPattern}></div>
                <div className={classes.rankCardContent}>
                  <Typography className={classes.rankCardTitle}>
                    {t('rank.promotion')}
                  </Typography>
                  
                  <div className={classes.currentRank} style={getRankStyle(editedUser.rank)}>
                    <TrendingUp style={{ marginRight: '8px' }} />
                    {language === 'en' ? 'Current Rank' : 'Rank Actual'}: {getCurrentRankDetails().label}
                  </div>

                  <Grid container spacing={3} alignItems="center">
                    <Grid item xs={12} md={8}>
                      <FormControl fullWidth className={classes.rankSelectField}>
                        <InputLabel>{language === 'en' ? 'Select Rank for Promotion' : 'Selectează Rank pentru Promovare'}</InputLabel>
                        <Select
                          value={selectedRank}
                          onChange={(e) => setSelectedRank(e.target.value)}
                          label={language === 'en' ? 'Select Rank for Promotion' : 'Selectează Rank pentru Promovare'}
                        >
                          {availableRanks.map((rank) => (
                            <MenuItem key={rank.value} value={rank.value}>
                              <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                <div
                                  style={{
                                    width: '12px',
                                    height: '12px',
                                    borderRadius: '50%',
                                    backgroundColor: rank.backgroundColor,
                                  }}
                                />
                                {rank.label}
                              </div>
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Grid>
                    <Grid item xs={12} md={4}>
                      <Button
                        variant="outlined"
                        className={classes.promotionButton}
                        onClick={handlePromotionRequest}
                        disabled={promotionLoading || !selectedRank}
                        startIcon={<TrendingUp />}
                        fullWidth
                      >
                        {promotionLoading 
                          ? (language === 'en' ? 'Submitting...' : 'Se trimite...')
                          : (language === 'en' ? 'Request Promotion' : 'Solicită Promovarea')
                        }
                      </Button>
                    </Grid>
                  </Grid>

                  {selectedRank && (
                    <Typography variant="body2" style={{ marginTop: '16px', opacity: 0.9 }}>
                      {language === 'en' 
                        ? `You are requesting promotion to ${availableRanks.find(r => r.value === selectedRank)?.label}. This request will be reviewed by an administrator.`
                        : `Soliciți promovarea la ${availableRanks.find(r => r.value === selectedRank)?.label}. Această cerere va fi revizuită de un administrator.`
                      }
                    </Typography>
                  )}
                </div>
              </div>
            )}
          </div>
        </Container>
      </Box>
      <NewFooter />
      <NewMadeWith />
      <NewScrollTop />
    </Fragment>
  );
};

export default ProfilePageMain;
